import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ElevatingProfessionalStandards from "./sections/ElevatingProfessionalStandards";
import OurCoastalLegacy from "./sections/OurCoastalLegacy";
import OurSpecializedSolutions from "./sections/OurSpecializedSolutions";
import ClientVoiceCarousel from "./sections/ClientVoiceCarousel";
import OurServiceArea from "./sections/OurServiceArea";
import GetYourCustomEstimate from "./sections/GetYourCustomEstimate";
import CoastalFootnotes from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ElevatingProfessionalStandards />
      <OurCoastalLegacy />
      <OurSpecializedSolutions />
      <ClientVoiceCarousel />
      <OurServiceArea />
      <GetYourCustomEstimate />
      <CoastalFootnotes />
    </div>;
}